﻿import { VueReCaptcha } from 'vue-recaptcha-v3'
import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import { IHotEditableFormParentVue } from "../../common";
import common = require("../../common");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");
import utilities = require("../utilities");
import context = require('../context');

@Component
class RecaptchaSecuriteVue extends Vue implements IHotEditableFormParentVue {
    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;
    culture?: common.Cultures;
    isVisibleToggleButton = false;
    forceUpdate = "1";
    initTrigger = '';
    bag = {};
    _bagTmp: {};
    _initialConcurrencySumCheck: string;
    _manageButtonsOnFormModeChange: boolean;
    /** Doit etre meme que WebConstants */
    _recaptchaAction: string;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        this._initialConcurrencySumCheck = initialConcurrencySumCheck;

        HotEditableFormLoader.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        const formName = (this as any).$initialData.formName;
        this.formManager = new HotEditableFormManager(this, formName, {
            loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false,
            embeddedContentModels: (((this as any).$initialData.embeddedContentModels || []) as common.IEmbeddedContentModel[]).sort((a, b) => {
                return a.order - b.order;
            })
        });
        this.shared = new SharedHotEditableParentForm(this.formManager);

        this.culture = context.culture.get();
        this._bagTmp = (this as any).$initialData.bag || {};
        this._recaptchaAction = (this as any).$initialData.recaptchaAction || null;

        this.$options.el = '#' + rootId;

        // reCAPTCHA v3 official language code
        const rcLanguageCodes = {};
        rcLanguageCodes[common.Cultures.fr] = 'fr';
        rcLanguageCodes[common.Cultures.en] = 'en';
        var rcLanguageCode = rcLanguageCodes[this.culture ?? common.Cultures.fr];
        Vue.use(VueReCaptcha, {
            siteKey: context.reCaptcha.siteKey,
            // /** ReCaptcha v3 options => https://github.com/AurityLab/recaptcha-v3/#load-options-usage */
            loaderOptions: {
                renderParameters: {
                    hl: rcLanguageCode
                },
                //     /** The container if you want to render the inline widget */
                //     container: null as string | Element,
                //     /** The positioning for the widget */
                //     badge: null as string,//'bottomright' or 'bottomleft' or 'inline'
                //     /** The size of the widget */
                //     size: null as string,//'invisible'
                //     /** The tab index of the widget */
                //     tabindex: null as number
            }
        });

        (this as any).$options.components["vue-recaptcha"] = VueReCaptcha;
    }
    closeReCaptcha() {
        if (this.$recaptchaInstance && (this.$recaptchaInstance as any).hideBadge)
            (this.$recaptchaInstance as any).hideBadge();
        return this;
    }
    destroyComponents() {
        this.formManager.destroyComponents();
        this.formManager = null;
        return this;
    }

    created() {
    }

    beforeMount() {
        this.initTrigger = "1";
    }

    mounted() {
        this.bag = this._bagTmp;

        if (!!this._initialConcurrencySumCheck)
            this.initConcurrencySumCheck(this._initialConcurrencySumCheck);
    }
    getBagRaw() {
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }
    private onInit(initTrigger: string, action: () => void | string) {
        if (!initTrigger)
            return '';
        this.initTrigger = '';
        if (action)
            action();
        return action ? action() || '' : '';
    }

    updateBagOnInit(initTrigger: string, key: string, value?: any) {
        return this.onInit(initTrigger, () => {
            //this.setToBag(key, value);
            this._bagTmp[key] = value;
            return value;
        });
    }

    /** vue-recaptcha-v3@1.9.0 (https://github.com/AurityLab/vue-recaptcha-v3/tree/v1.9.0) */
    onNextButtonClick(event: Event) {
        event.preventDefault();

        // (optional) Wait until recaptcha has been loaded.
        this.$recaptchaLoaded();

        // Execute reCAPTCHA with action
        if (!this._recaptchaAction) throw "Recaptcha: L'action doit être définie.";
        const token = this.$recaptcha(this._recaptchaAction);

        token.then(x => {
            this.applyUpdate(x, common.HotEditableActionTypes.apply);
        });
    }

    applyUpdate(actionValue?: string, actionType?: common.HotEditableActionTypes) {
        this.formManager.applyUpdate(actionValue, actionType);
        return this;
    }

    updateFieldTextualValue(fieldName: string, value?: string) {
        value = value || '';
        if (!fieldName)
            throw "L'argument 'fieldName' est requis.";
        const f = this.formManager.getFieldByName(fieldName);
        if (f)
            f.setFromTextualValue(value);
        return this;
    }

    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    setToBag(key: string, value: any) {
        this.$set(this.bag, key, value);
        return this;
    }

    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }

    setBooleanToBag(key: string, value: boolean) {
        this.setToBag(key, value === true);
        return this;
    }

    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }
    updateBag(updated: common.IBag) {
        if (!updated)
            return this;
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }
        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }

    private initConcurrencySumCheck(sumCheck?: string) {
        const f = this.formManager.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || '');
        return this;
    }

    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }

    // setActionConfirmation(key: string, action?: () => void) {
    //     if (!key)
    //         throw "L'argument 'key' est NULL.";

    //     const f = this.formManager.getFieldByName(key);

    //     if (!f)
    //         throw "Le champ correspondant au nom '" + key + "' n'existe pas.";

    //     f.setFromTextualValue("true");

    //     if (action)
    //         this.$nextTick(action);

    //     return this;
    // }
    refreshEmbeddedComponents(urlParameters?: {}) {
        this.formManager.refreshEmbeddedComponents(urlParameters);
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }
}

export = RecaptchaSecuriteVue;